export function LightClickHandler(RowArray,RowName)
{
    const Scene = RowArray[0].scene;
    const DrawArray = [{},{}];
    Scene.DrawDistance = RowArray[1].x - RowArray[0].x;

    //Checks to see which row has been clicked by checking names
    //Each color is a different asset. So if [0] and [1]
    //are the same name, it is a single color array

    if(RowArray[0].frame.name === RowArray[1].frame.name)//single light string
    {
        DrawArray[1].Name = DrawArray[0].Name = RowArray[0].frame.name;
    }
    else if (RowArray[0].frame.name === RowArray[2].frame.name)//Two light string
    {
        DrawArray[0].Name = RowArray[0].frame.name;
        DrawArray[1].Name = RowArray[1].frame.name;
    }
    else//Multi-light string
    {
        for(let inRow in RowArray)
        {
            DrawArray[inRow] = {};
            DrawArray[inRow].Name = RowArray[inRow].frame.name;
        }
    }

    Scene.DrawArray = DrawArray;
}

export function onBlinkButtonHandler(Scene,BackGround,MoveToButton,BackLight,Tween)
{
    //console.log(Scene.LightsBlinking);
    if(!Scene.LightsBlinking)
    {
        Scene.LightGroup.getChildren().forEach((element,index) =>
        {
            let num = parseInt(index);
            if(num%2)
            {
                element.alpha = 0;
            }
        });

        _EvenOn(Scene);

        Scene.LightsBlinking = true;

        BackGround.x = MoveToButton.x;
        BackGround.y = MoveToButton.y;
        BackLight.setPosition(MoveToButton.x,MoveToButton.y);
        Scene.LightGroup.add(BackLight);
        //Tween.restart();
        //console.log(Tween);
        //Tween.restart();//Restart has to be called twice to restart the tween
    }
}

export function onSolidButtonHandler(Scene,BackGround,MoveToButton,BackLight,Tween)
{
    if(Scene.LightsBlinking)
    {
        Scene.LightGroup.getChildren().forEach((element) =>
        {
            element.alpha = 1;
        });

        Scene.LightsBlinking = false;

        BackGround.x = MoveToButton.x;
        BackGround.y = MoveToButton.y;
        BackLight.setPosition(MoveToButton.x,MoveToButton.y);
        //Tween.pause();
        BackLight.setAlpha(1);
        //console.log(Tween);      
    }
}

function _EvenOn(Scene)
{
    Scene.time.addEvent({delay:800,callback:_InEvenOn});

    function _InEvenOn()
    {
        Scene.LightGroup.getChildren().forEach((element,index) =>
        {
            let num = parseInt(index);
            if(num%2)
            {
                element.alpha = 1;
            }
            else
            {
                element.alpha = 0;
            }
        });
        if(Scene.LightsBlinking)
        {
            _EvenOff(Scene);
        }
        else
        {
            Scene.LightGroup.getChildren().forEach((element) =>
            {
                element.alpha = 1;
            });
        }
    }
}

function _EvenOff(Scene)
{
    Scene.time.addEvent({delay:800,callback:_InEvenOff});
    function _InEvenOff()
    {
        Scene.LightGroup.getChildren().forEach((element,index) =>
        {
            let num = parseInt(index);
            if(num%2)
            {
                element.alpha = 0;
            }
            else
            {
                element.alpha = 1;
            }
        });
        if(Scene.LightsBlinking)
        {
            _EvenOn(Scene);
        }
        else
        {
            Scene.LightGroup.getChildren().forEach((element) =>
            {
                element.alpha = 1;
            });
        }
    }
}